import Heading, { type Level } from '@tiptap/extension-heading';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { ContentHeadingView } from './content-heading-view';

export const ContentHeading = Heading.extend({
  addNodeView() {
    return ReactNodeViewRenderer(ContentHeadingView);
  },
  addKeyboardShortcuts() {
    return {
      Enter: function (args) {
        const { editor } = args;
        const { from } = editor.state.selection;
        const pos = editor.state.doc.resolve(from);
        if (pos.parent.type.name === 'heading') {
          const { level = 1 } = pos.parent.attrs;
          const { depth } = pos;
          const headingNode = pos.node(depth);
          const headingStartPos = pos.before(depth);
          const headingText = headingNode.textContent;
          const cursorPosInHeading = from - headingStartPos - 1;
          const textBeforeCursor = headingText.slice(0, cursorPosInHeading);
          const textAfterCursor = headingText.slice(cursorPosInHeading);
          if (textAfterCursor.length === 0) {
            // if there's no text after cursor, create empty heading
            const headingEndPos = headingStartPos + headingNode.nodeSize;
            const newHeading = editor.schema.nodes.heading.create(
              { level: level as Level },
              editor.schema.text('t') // temporary text
            );
            editor.commands.insertContentAt(headingEndPos, newHeading);
            // delete temporary text
            editor.commands.deleteRange({
              from: headingEndPos + 1,
              to: headingEndPos + 2,
            });
            editor.commands.focus(headingEndPos);
            return true;
          }
          // update current heading with text before cursor
          if (textBeforeCursor.length > 0) {
            const newCurrentHeading = editor.schema.nodes.heading.create(
              { level: level as Level },
              editor.schema.text(textBeforeCursor)
            );
            editor
              .chain()
              .command(function (args) {
                const { tr } = args;
                tr.replaceRangeWith(
                  headingStartPos,
                  headingStartPos + headingNode.nodeSize,
                  newCurrentHeading
                );
                return true;
              })
              .run();
          } else {
            // if no text before cursor, remove the current heading
            editor.commands.deleteRange({
              from: headingStartPos,
              to: headingStartPos + headingNode.nodeSize,
            });
          }
          const insertPos =
            textBeforeCursor.length > 0
              ? headingStartPos + textBeforeCursor.length + 2
              : headingStartPos;
          const newHeading = editor.schema.nodes.heading.create(
            { level: level as Level },
            editor.schema.text(textAfterCursor)
          );
          editor.commands.insertContentAt(insertPos, newHeading);
          editor.commands.focus(insertPos + 1);
          return true;
        }
        return false;
      },
    };
  },
  draggable: true,
});
